import { render, staticRenderFns } from "./EncabezadoRecuperacionPass.vue?vue&type=template&id=d486f20c&scoped=true"
import script from "./EncabezadoRecuperacionPass.vue?vue&type=script&lang=js"
export * from "./EncabezadoRecuperacionPass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d486f20c",
  null
  
)

export default component.exports